import { createContext, useContext, type ReactNode } from 'react';

/**
 * Portal-specific controls shown in the top bar on every page (desktop header and the mobile top
 * bar), for example Hub's link sharing and order-alert status. Absent for other portals.
 */
const HeaderToolsContext = createContext<ReactNode>(null);

export const HeaderToolsProvider = HeaderToolsContext.Provider;
export const useHeaderTools = () => useContext(HeaderToolsContext);
